<app>

  <header>
    <div class="nav">
      <a href="">
        <img src={ logo } alt="">
      </a>
      <div class="items">
        <a href="#sobre">SOBRE</a>
        <!-- <a href="#produtos">PRODUTOS</a> -->
        <!-- <a href="#clientes">CLIENTES</a> -->
        <a href="#contato" class="#/contact">CONTATO</a>
      </div>
    </div>
  </header>



  <main>
    <pg-home />
  </main>

  <footer>
    <span>© 2020 Todos os direitos reservados</span>
    <!-- <span>61 9.9985-6142</span> -->

  </footer>

  <script>
    import route from 'riot-route'
    import './app.scss'
    import logo from './media/logo.png'

    // Components
    import PgHome from './components/pg-home.riot'

    export default {
      logo,
      components: {
        PgHome
      },
      onMounted(props, state) {
        self = this

        // routers
        route('/', self.controllers.pgHome)

        document.addEventListener('scroll', e => {
         if(window.scrollY > 20) {
           this.$('.nav').classList.add('scrolled')
           this.$('.nav').classList.remove('top')
         } else {
          this.$('.nav').classList.remove('scrolled')
          this.$('.nav').classList.add('top')
         }
        })

      },
      controllers: {
        async pgHome() {
          self.actions.changeViewTo('pgHome')
          self.update()
        },
        async pgContact() {
          self.actions.changeViewTo('pgContact')
          self.update()
        }
      }
    }


  </script>
</app>

